import { FC } from 'react';
import { Circle, HStack, Text } from '@chakra-ui/react';

import SunshineIconButton from 'components/_core/IconButton';
import SunshineCard from 'components/_core/SunshineCard';
import SunshineDropdown from 'components/_core/SunshineDropdown';
import SunshineIcon from 'components/_core/SunshineIcon';

import locales from '../locales';

interface DocumentReceiptProps {
  documentUrl: string;
  onDocumentDelete: () => void;
}

const DocumentReceipt: FC<DocumentReceiptProps> = (props) => {
  const { documentUrl, onDocumentDelete } = props;

  const onViewDocument = () => {
    window.open(documentUrl, '_blank');
  };

  return (
    <SunshineCard>
      <SunshineCard.Content>
        <HStack justifyContent="space-between" width="100%">
          <HStack>
            <Circle
              bgColor="grey.200"
              color="grey.800"
              minHeight="space-40"
              minWidth="space-40"
            >
              <SunshineIcon name="file" size="icon-20" />
            </Circle>
            <Text fontWeight="weight-500">{locales.receipt}</Text>
          </HStack>
          <SunshineDropdown>
            <SunshineDropdown.Trigger>
              <SunshineIconButton
                aria-label="Actions"
                icon="vertical-ellipsis"
                variant="secondary"
              />
            </SunshineDropdown.Trigger>

            <SunshineDropdown.List>
              <SunshineDropdown.Item onClick={onViewDocument}>
                <HStack>
                  <Circle
                    bgColor="grey.200"
                    color="grey.800"
                    minHeight="space-24"
                    minWidth="space-24"
                  >
                    <SunshineIcon name="eye-open" size="icon-16" />
                  </Circle>
                  <Text fontWeight="weight-500">{locales.see}</Text>
                </HStack>
              </SunshineDropdown.Item>
              <SunshineDropdown.Divider />
              <SunshineDropdown.Item onClick={onDocumentDelete}>
                <HStack>
                  <Circle
                    bgColor="grey.200"
                    color="red.600"
                    minHeight="space-24"
                    minWidth="space-24"
                  >
                    <SunshineIcon name="trash" size="icon-16" />
                  </Circle>
                  <Text color="red.600" fontWeight="weight-500">
                    {locales.delete}
                  </Text>
                </HStack>
              </SunshineDropdown.Item>
            </SunshineDropdown.List>
          </SunshineDropdown>
        </HStack>
      </SunshineCard.Content>
    </SunshineCard>
  );
};

export default DocumentReceipt;
